const proxyLevel = () => import('@/pages/proxy/level/index.vue');

export default [{
    path: '/proxy/level',
    component: proxyLevel,
    meta: [{
        name: '代理管理',
		activeRoute: '/proxy/manage'
    },
    {
        name: '等级配置',
        activeRoute: '/proxy/level'
    }]
}];